import React, { useEffect, useState } from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { PHYSICIAN_ENGAGEMENT_AFFILIATION_TYPE_CHART_OPTIONS } from './constants';
import { useSelector } from 'react-redux';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { capitalizeFirstLetter } from '../../../../utility';

function PhysicianEngagementAffiliationType() {
    const {
        isLoading,
        physicianEngagementAffiliationTypeDonutChartData = [],
    } = useSelector((state) => state.digitalEngagement);

    const [updatedChartOptions, setUpdatedChartOptions] = useState({
        ...PHYSICIAN_ENGAGEMENT_AFFILIATION_TYPE_CHART_OPTIONS,
        series: [
            {
                name: null,
                data: physicianEngagementAffiliationTypeDonutChartData,
                size: '100%',
                innerSize: '50%',
                showInLegend: true,
                borderRadius: 0,
            },
        ],
    });

    useEffect(() => {
        setUpdatedChartOptions({
            ...PHYSICIAN_ENGAGEMENT_AFFILIATION_TYPE_CHART_OPTIONS,
            tooltip: {
                formatter: function () {
                    return `${capitalizeFirstLetter(this?.point?.name || '')}: ${this.y.toFixed(2)}%`;
                },
            },
            legend: {
                layout: 'vertical',
                align: 'center',
                verticalAlign: 'bottom',
                labelFormatter: function () {
                    return `${capitalizeFirstLetter(this?.name || '')}: ${this.y.toFixed(2)}%`;
                },
                itemStyle: { fontWeight: 'normal' },
            },
            series:
                physicianEngagementAffiliationTypeDonutChartData.length > 0
                    ? [
                          {
                              name: null,
                              data: physicianEngagementAffiliationTypeDonutChartData,
                              size: '100%',
                              innerSize: '50%',
                              showInLegend: true,
                              borderRadius: 0,
                          },
                      ]
                    : [],
        });
    }, [physicianEngagementAffiliationTypeDonutChartData]);

    return (
        <Box className="container-p-24-br-16 bg-gray-50">
            <Box>
                <Typography className="text-md-medium gray-900">
                    Physician Engagement Affiliation Type
                </Typography>
            </Box>
            {isLoading ? (
                <Skeleton height={400} variant="rectangular" width="100%" />
            ) : (
                <HighchartsReact
                    highcharts={Highcharts}
                    options={updatedChartOptions}
                />
            )}
        </Box>
    );
}

export default PhysicianEngagementAffiliationType;
